module.exports = __webpack_public_path__ + "img/lloyds-horse.5873ae32.svg";